// extracted by mini-css-extract-plugin
export default {"loader":"Loader-module--loader--BZ0c+","robot-container":"Loader-module--robot-container--gkORI","robot":"Loader-module--robot--gn9DK","changeBg":"Loader-module--changeBg--zr+G4"};